module.exports = __webpack_public_path__ + "images/logo-reverse-full.svg";


//////////////////
// WEBPACK FOOTER
// ./images/logo-reverse-full.svg
// module id = 151
// module chunks = 0